import { configService } from "../index";
import { BaseRequests, BaseRequestsInterface } from "./BaseRequests";
import { ExperienceInquiry } from '@/models/experience-inquiry';

export default {
	...BaseRequests(
		() => configService.experienceInquiry,
		"experienceInquiry",
		() => new ExperienceInquiry()
	)
} as BaseRequestsInterface;
